import { FC, ReactNode } from "react";
import { Col } from "reactstrap";

type Props = {
    children: ReactNode;
};

export const HalfPageColumn: FC<Props> = (props: Props) => {
    const { children } = props;

    return <Col sm={{ size: 6, offset: 3 }}>{children}</Col>;
};
